import React, { useState } from "react";
import { DotsVertical as DotsVerticalIcon } from "@actinc/dls/icons";
import {
  IconButton,
  Box,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";

const SimpleTable = ({
  actions = [],
  columns = [],
  error,
  rows = [],
  tableProps,
  isCreateContent = false,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState({ idx: "", vals: "" });

  const closeActionMenu = () => {
    setSelectedRow(null);
    setAnchorEl(null);
  };
  const handleMenuItemClick = (onClick) => (e) => {
    onClick(selectedRow)(e);
    closeActionMenu();
  };
  const openActionMenu = (idx) => (row) => (e) => {
    setSelectedRow({
      idx,
      vals: row,
    });
    setAnchorEl(e.currentTarget);
  };

  const menuProps = {
    anchorEl,
    id: "table-row-actions-menu",
    onClose: closeActionMenu,
    open: Boolean(anchorEl),
  };

  return (
    <TableContainer component={Paper}>
      <Table size="small" {...tableProps}>
        <TableHead>
          <TableRow>
            {!!actions.length && (
              <TableCell key="actions-header">Actions</TableCell>
            )}
            {columns.map(({ title, ...rest }, idx) => {
              return (
                <TableCell key={`${title}-${idx}`} {...rest}>
                  {title}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => {
            const columnKeys = columns
              .filter((column) => column["identifier"] !== "actions")
              .map((column) => column["identifier"]);
            const uuid = uuidv4();
            return (
              <TableRow key={`table-row-position-${row?.id || uuid}`}>
                {!!actions.length && (
                  <TableCell>
                    <Box sx={{ position: "relative" }}>
                      <IconButton
                        aria-controls="table-row-actions-menu"
                        aria-label={`icon-btn-row-${index}`}
                        color="primary"
                        onClick={openActionMenu(index)(row)}
                        size="small"
                      >
                        <DotsVerticalIcon />
                      </IconButton>
                      {selectedRow?.idx === index && (
                        <Menu
                          {...menuProps}
                          slotProps={
                            isCreateContent
                              ? {
                                  paper: {
                                    style: { maxHeight: 150 },
                                  },
                                }
                              : {}
                          }
                          disablePortal={isCreateContent}
                          sx={
                            isCreateContent
                              ? {
                                  position: "absolute",
                                  top: "-20px",
                                  left: "22px",
                                }
                              : {}
                          }
                        >
                          {actions.map(
                            ({ label, onClick, ...menuItemProps }, idx) => (
                              <MenuItem
                                dense
                                key={`${label}-${idx}`}
                                onClick={handleMenuItemClick(onClick)}
                                {...menuItemProps}
                              >
                                {label}
                              </MenuItem>
                            ),
                          )}
                        </Menu>
                      )}
                    </Box>
                  </TableCell>
                )}
                {columnKeys.map((val, idx) => {
                  const sx =
                    columns.find((c) => c.identifier === val)?.sx || {};
                  return (
                    <TableCell
                      aria-label={`${row[val]}`}
                      key={`simple-table-value-${idx}-${row[val]}`}
                      sx={sx}
                    >
                      {row[val]}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export { SimpleTable };
